module.exports = __webpack_public_path__ + "img/leaf.cfe3bfbc.svg";